import { apiWrapper } from "./apiLayer";
import {GetRecordDataResponse } from "@/types/api.types";

export const BlockchainAPI = {
    getRecordData: async function (dataObj:{internalTxID: string}): Promise<{ success: boolean; data?: GetRecordDataResponse; message?: string }> {
        const response = await apiWrapper("recordVerification", {
            method: "POST",
            body: JSON.stringify(dataObj),
        }, true);
        return response;
    },
};
